import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { ArrayMinSize, IsArray, IsEmail, IsNotEmpty } from "class-validator"
import { CompanyListModel } from "@/modules/company/models/companyListModel"
import { CostCenterModel } from "./costCenterModel"
import { RFQExtended } from "../args/rfqExtended"

@Serializable
export class RFSTrygExtended extends RFQExtended {
  hpNumber: string = ""
  entity: CompanyListModel

  @IsArray({
    message: "common:form.errors.empty",
    groups: ["edit_tryg_details"],
  })
  @ArrayMinSize(1, {
    message: "common:form.errors.empty",
    groups: ["edit_tryg_details"],
  })
  languageRequired: string[] = []
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["edit_tryg_managers"],
  })
  hiringManagerName: string = ""

  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["edit_tryg_managers"],
  })
  positionNumber: string = ""

  @IsEmail(undefined, {
    message: "common:form.errors.email",
    groups: ["edit_tryg_managers"],
  })
  invoiceReceiverEmail: string = ""
  costCenters: CostCenterModel[]
  contractOrderNumbers: string[] = []

  constructor(init?: Partial<RFSTrygExtended>) {
    super(init)
    this.hpNumber = init?.hpNumber || ""
    this.entity = init?.entity || new CompanyListModel()
    this.languageRequired = init?.languageRequired || []
    this.hiringManagerName = init?.hiringManagerName || ""
    this.positionNumber = init?.positionNumber || ""
    this.invoiceReceiverEmail = init?.invoiceReceiverEmail || ""
    this.costCenters = init?.costCenters || []
    this.contractOrderNumbers = init?.contractOrderNumbers || []
    Object.assign(this, init)
  }
}
